import React from "react";
import Chart from "react-apexcharts";
import {
  Card,
  CardBody,
  CardHeader,
  Typography,
} from "@material-tailwind/react";
import { useTranslation } from "react-i18next";

const RevenueChart = ({ data = [] }) => {
  const { t } = useTranslation("home");
  const categories = data.map((item) => item.month);

  const series = [
    {
      name: "Revenue",
      data: data.map((item) => Number(item.amount)),
    },
  ];

  const options = {
    chart: {
      type: "area",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },

    stroke: {
      curve: "smooth",
      width: 3,
    },

    dataLabels: {
      enabled: false,
    },

    xaxis: {
      categories,
    },

    yaxis: {
      labels: {
        formatter: function (value) {
          return "SAR" + value.toLocaleString();
        },
      },
    },

    tooltip: {
      y: {
        formatter: function (value) {
          return "SAR" + value.toLocaleString();
        },
      },
    },

    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.45,
        opacityTo: 0.05,
      },
    },

    grid: {
      borderColor: "#ECEFF1",
      strokeDashArray: 4,
    },

    markers: {
      size: 5,
    },
  };

  const totalRevenue = data.reduce(
    (sum, item) => sum + Number(item.amount),
    0
  );

  return (
    <Card className="shadow-md">
      <CardHeader
        floated={false}
        shadow={false}
        className="rounded-none bg-white px-6 py-4"
      >
        <div className="flex items-center justify-between">
          <div>
            <Typography variant="h5">
              {t('monthlyRevenue')}
            </Typography>

            {/* <Typography
              variant="small"
              color="gray"
            >
              Revenue collected this year
            </Typography> */}
          </div>

          {/* <div className="text-right">
            <Typography
              variant="small"
              color="gray"
            >
              Total
            </Typography>

            <Typography
              variant="h5"
              color="green"
            >
              SAR{totalRevenue.toLocaleString()}
            </Typography>
          </div> */}
        </div>
      </CardHeader>

      <CardBody>
        <Chart
          options={options}
          series={series}
          type="area"
          height={350}
        />
      </CardBody>
    </Card>
  );
};

export default RevenueChart;